import { render } from "./internal-consumptions.vue?vue&type=template&id=b88102da"
import script from "./internal-consumptions.vue?vue&type=script&lang=js"
export * from "./internal-consumptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__